import React, { useState } from "react";
import "./GestionAlumniCard.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Modal from "Components/Modal/Modal";
import { convert, formatDate } from "Services/functions";
import { BiCheckCircle, BiUser } from "react-icons/bi";
import { RiCloseCircleLine } from "react-icons/ri";
import { FiAlertCircle } from "react-icons/fi";
import { GiWorld } from "react-icons/gi";
import axios from "axios";
import { updateRequests } from "Redux/Actions/requestsActions";
import { formatPhoneNumberIntl } from "react-phone-number-input";

const GestionRecruteurCard = (props) => {
  let values = {
    ...props.values,
  };

  const [isVisibleDetails, setIsVisibleDetails] = useState(false);

  const manageRequest = (decision) => {
    let url = `${process.env.REACT_APP_BASE_URL_API}/alumni_membership_requests/${values.id}/${decision}`;
    const data = {};
    axios
      .post(url, data, {
        headers: props.auth.token
          ? {
              accept: "application/json",
              Authorization: `Bearer ${props.auth.token}`,
            }
          : {
              accept: "application/json",
            },
      })
      .then(() => {
        if (decision === "validate") {
          values.validated = 1;
          props.uploadToast.current.show({
            severity: "success",
            summary: "Succès : ",
            detail:
              "La demande d'adhésion de " +
              `${values.recruterFirstname} ${values.recruterSurname}` +
              " a bien été validée",
            life: 3000,
          });
          informWS();
        } else {
          values.validated = 0;
          props.cancelToast.current.show({
            severity: "error",
            summary: "Suppression : ",
            detail:
              "La demande d'adhésion de " +
              `${values.recruterFirstname} ${values.recruterSurname}` +
              " a bien été refusée",
            life: 3000,
          });
        }
      })
      .catch((error) => {
        props.auth.toast.current.show({
          severity: "error",
          summary: "Erreur : ",
          detail:
            error.message || "Une erreur est survenue lors de la validation",
          life: 4000,
        });
      })
      .finally(() => {
        props.handleFilter();
      });
  };

  const informWS = () => {
    const body = {
      givenName: props.values.alumniFirstname,
      sn: props.values.alumniSurname,
      supannOIDCDateDeNaissance: props.values.birthday.split("T")[0],
      pager: props.values.alumniTelephone,
      supannMailPerso: props.values.alumniEmail,
      alumni: true,
    };
    axios
      .post("http://relai-reseaupro01.univ-paris1.fr/fromManual", body)
      .then(() => {
        props.auth.toast.current.show({
          severity: "success",
          summary: "Succès : ",
          detail: "Informations envoyées au Web Service",
          life: 4000,
        });
      })
      .catch(() => {
        props.auth.toast.current.show({
          severity: "error",
          summary: "Erreur : ",
          detail: "Les informations n'ont pas pu être envoyées au Web Service",
          life: 4000,
        });
      });
  };

  return (
    <div className="member_card_formulaire cardHover">
      <div className="member_card_image alumni">
        <BiUser></BiUser>
        {/* {props.role === "etudiant" && <GiLaurels></GiLaurels>} */}
      </div>
      <div className="member_card_container">
        <div
          className="member_card_container__left"
          onClick={() => {
            setIsVisibleDetails(true);
          }}
        >
          {/* <div className="member_card_container__left__title">
            <h1>{values.companyName}</h1>
          </div> */}
          <div className="member_card_container__left__informations">
            <div className="member_card_container__left__informations__name">
              <BiUser></BiUser>
              <span>{values.alumniFirstname + " " + values.alumniSurname}</span>
            </div>
            {values.alumniCountry && (
              <div className="member_card_container__left__informations__status">
                <GiWorld></GiWorld>
                <span>{values.alumniCountry}</span>
              </div>
            )}
            <div className="member_card_container__left__informations__date">
              <FiAlertCircle></FiAlertCircle>
              <span>{convert(values.createdAt)}</span>
            </div>
          </div>
        </div>
        <div className="member_card_container__right">
          {values.status === "En attente" && (
            <BiCheckCircle
              className="member_card_container__right__validate"
              onClick={() => {
                manageRequest("validate");
              }}
            ></BiCheckCircle>
          )}
          {values.status === "En attente" && (
            <RiCloseCircleLine
              className="member_card_container__right__refuse"
              onClick={() => {
                manageRequest("refuse");
              }}
            ></RiCloseCircleLine>
          )}
        </div>
      </div>

      {isVisibleDetails && (
        <Modal
          visible={isVisibleDetails}
          setVisible={setIsVisibleDetails}
          header="Détails de la demande d'adhésion"
        >
          <div className="member_card_formulaire_modal">
            <div className="member_name">
              <span>{"Demandeur(euse):"}</span>
              <div>{values.alumniFirstname + " " + values.alumniSurname}</div>
            </div>
            {values.birthday && (
              <div className="member_birthday">
                <span>Date de naissance :</span>
                <div>{formatDate(values.birthday)}</div>
              </div>
            )}
            {values.alumniCountry && (
              <div className="member_status">
                <span>Pays :</span>
                <div>{values.alumniCountry}</div>
              </div>
            )}
            {values.graduationYear && (
              <div className="member_graduation">
                <span>Année du diplôme :</span>
                <div>{formatDate(values.graduationYear)}</div>
              </div>
            )}
            <div className="member_mail">
              <span>Adresse mail:</span>
              <div>{values.alumniEmail}</div>
            </div>
            {values.alumniTelephone && (
              <div className="member_telephone">
                <span>Numéro de téléphone:</span>
                <div>
                  {formatPhoneNumberIntl(values.alumniTelephone) ||
                    values.alumniTelephone}
                </div>
              </div>
            )}
            {values.membershipRequestReason && (
              <div className="member_reason">
                <span>Raison de la demande :</span>
                <div>
                  <br />
                  {values.membershipRequestReason}
                </div>
              </div>
            )}
            <div className="member_buttons">
              <button
                className="btn-bleu valider_button"
                onClick={() => {
                  manageRequest("validate");
                  setIsVisibleDetails(false);
                }}
              >
                Valider la demande d&apos;adhésion
              </button>
              <button
                className="btn-blanc refuser_button"
                onClick={() => {
                  manageRequest("refuse");
                  setIsVisibleDetails(false);
                }}
              >
                Refuser la demande d&apos;adhésion
              </button>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

GestionRecruteurCard.propTypes = {
  memberData: PropTypes.object,
  onValidation: PropTypes.func,
  values: PropTypes.object,
  handleUpdateRequests: PropTypes.func,
  requests: PropTypes.object,
  uploadToast: PropTypes.any,
  cancelToast: PropTypes.any,
  auth: PropTypes.object,
  handleFilter: PropTypes.func,
};

const mapStateToProps = (state) => ({
  requests: state.requests,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateRequests: (value) => {
    dispatch(updateRequests(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(GestionRecruteurCard);
